import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/filterbar.scss';

const FilterBar = ({ filters = [], handleFilterClear }) => {
  if (!filters.length) {
    return null;
  }

  const labels = filters.map(({ data, label, name, dataAlt }, i) => {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      return null;
    }

    return (
      <div className="filter-label" key={i} onClick={() => handleFilterClear(name)}>
        {label}: <strong>{Array.isArray(data) ? dataAlt.join(', ') : data}</strong>
        <div className="filter-clear">
          <i className="fas fa-times" />
        </div>
      </div>
    );
  });

  return <div className="filter-bar">{labels}</div>;
};

FilterBar.propTypes = {
  filters: PropTypes.array,
  handleFilterClear: PropTypes.func,
};

export default FilterBar;
